import { combineReducers } from 'redux';
import * as ActionTypes from '../actions';
import auth from './auth';
import i18n from './i18n';
import cycles from './cycles';

function cycleAttachmentForm(state = { data: null }, action) {
	switch (action.type) {
		default:
			return state;
	}
}

const rootReducer = combineReducers({
	login: ActionTypes.login.reducer,
	dashboardList: ActionTypes.listDashboard.reducer,
	equipmentForm: ActionTypes.formEquipment.reducer,
	userForm: ActionTypes.formUser.reducer,
	equipmentTypeForm: ActionTypes.formEquipmentType.reducer,
	cycleInfo: ActionTypes.infoCycle.reducer,
	clientForm: ActionTypes.formClient.reducer,
	lookupTypeForm: ActionTypes.formLookupType.reducer,
	lookupTypeList: ActionTypes.listLookupType.reducer,
	lookupForm: ActionTypes.formLookup.reducer,
	lookupList: ActionTypes.listLookup.reducer,
	modelForm: ActionTypes.formModel.reducer,
	topFilterList: ActionTypes.listTopFilter.reducer,
	indicatorForm: ActionTypes.formIndicator.reducer,
	lotDetailForm: ActionTypes.formLotDetail.reducer,
	taskForm: ActionTypes.formTask.reducer,
	taskAssignmentForm: ActionTypes.formTaskAssignment.reducer,
	taskTypeForm: ActionTypes.formTaskType.reducer,
	cycleAttachmentForm,
	roleForm: ActionTypes.formRole.reducer,
	reusabletestpackForm: ActionTypes.formReusableTestPack.reducer,
	holidayForm: ActionTypes.formHoliday.reducer,
	incubatorCycleList: ActionTypes.listIncubatorCycle.reducer,
	incubatorCycleDetailList: ActionTypes.listIncubatorCycleDetail.reducer,
	userInfo: ActionTypes.infoUser.reducer,
	incubatorCycleDetailPendingList: ActionTypes.listIncubatorCycleDetailPending.reducer,
	userInfoProfile: ActionTypes.infoUserProfile.reducer,
	endoScopeList: ActionTypes.listEndoScope.reducer,
	endoScopeForm: ActionTypes.formEndoScope.reducer,
	endoScopeCodeList: ActionTypes.listEndoScopeCode.reducer,
	endoScopeCodeForm: ActionTypes.formEndoScopeCode.reducer,
	authorizedClientsForm: ActionTypes.formAuthorizedClients.reducer,
	hospitalForm: ActionTypes.formHospital.reducer,
	topicPermissionForm: ActionTypes.formTopicPermission.reducer,
	assetsForm: ActionTypes.formAssets.reducer,
	asstescodeForm: ActionTypes.formAssetsCode.reducer,
	i18n,
	auth,
	cycles,
	uploadDiagnosticsInfo: ActionTypes.uploadDiagnosticsInfo.reducer,
	uploadCycleFiles: ActionTypes.uploadCycleInfo.reducer
});

export default rootReducer
